
class CheeckyMonkeyGame {
    constructor() {
        // Detectar el tamaño de pantalla y configurar dimensiones apropiadas
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const isMobile = screenWidth < 768;
        const isTablet = screenWidth >= 768 && screenWidth < 1024;
        
        // Configurar dimensiones base según el dispositivo
        let gameWidth, gameHeight;
        if (isMobile) {
            // Para móviles: usar orientación portrait
            gameWidth = Math.min(screenWidth, 480);
            gameHeight = Math.min(screenHeight, 800);
        } else if (isTablet) {
            // Para tablets: usar orientación landscape
            gameWidth = Math.min(screenWidth, 1024);
            gameHeight = Math.min(screenHeight, 600);
        } else {
            // Para desktop: mantener dimensiones originales
            gameWidth = 1280;
            gameHeight = 720;
        }
        
        this.config = {
            type: Phaser.AUTO,
            width: gameWidth,
            height: gameHeight,
            parent: 'game-container',
            backgroundColor: '#111',
            physics: {
                default: 'arcade',
                arcade: {
                    gravity: { y: 300 },
                    debug: false
                }
            },
            scene: [BootScene, PreloadScene, MenuScene, GameScene, WinScene],
            scale: {
                mode: Phaser.Scale.FIT,
                autoCenter: Phaser.Scale.CENTER_BOTH,
                min: {
                    width: 320,
                    height: 480
                },
                max: {
                    width: 1920,
                    height: 1080
                }
            }
        };
        
        // Guardar información del dispositivo para uso en las escenas
        this.deviceInfo = {
            isMobile,
            isTablet,
            screenWidth,
            screenHeight,
            gameWidth,
            gameHeight
        };
        
        this.game = new Phaser.Game(this.config);
        
        // Pasar información del dispositivo a las escenas
        this.game.registry.set('deviceInfo', this.deviceInfo);
        
        // Configurar eventos táctiles para móviles
        if (isMobile) {
            this.setupMobileControls();
        }
    }
    
    setupMobileControls() {
        // Prevenir el comportamiento por defecto de gestos táctiles
        document.addEventListener('touchstart', (e) => {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        }, { passive: false });
        
        document.addEventListener('touchmove', (e) => {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        }, { passive: false });
        
        // Prevenir zoom con doble toque
        let lastTouchEnd = 0;
        document.addEventListener('touchend', (e) => {
            const now = (new Date()).getTime();
            if (now - lastTouchEnd <= 300) {
                e.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
        
        // Prevenir el menú contextual en dispositivos móviles
        document.addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });
    }
}

// Escena de arranque
class BootScene extends Phaser.Scene {
    constructor() {
        super({ key: 'BootScene' });
    }
    
    create() {
        this.scene.start('PreloadScene');
    }
}

// Escena de precarga
class PreloadScene extends Phaser.Scene {
    constructor() {
        super({ key: 'PreloadScene' });
    }
    
    preload() {
        // Crear barra de progreso
        const progressBar = this.add.graphics();
        const progressBox = this.add.graphics();
        
        
        const width = this.cameras.main.width;
        const height = this.cameras.main.height;
        
        progressBox.fillStyle(0x222222, 0.8);

        //xPos = isMobile ? 50 : 240;
        progressBox.fillRect(width/2-150, 270, 320, 50);

        const loadingText = this.make.text({
            x: width / 2,
            y: height / 2 - 50,
            text: 'Cargando...',
            style: {
                font: '20px monospace',
                fill: '#ffffff'
            }
        });
        loadingText.setOrigin(0.5, 0.5);
        
        const percentText = this.make.text({
            x: width / 2,
            y: height / 2 - 5,
            text: '0%',
            style: {
                font: '18px monospace',
                fill: '#ffffff'
            }
        });
        percentText.setOrigin(0.5, 0.5);
        
        const assetText = this.make.text({
            x: width / 2,
            y: height / 2 + 50,
            text: '',
            style: {
                font: '14px monospace',
                fill: '#ffffff'
            }
        });
        assetText.setOrigin(0.5, 0.5);
        
        // Actualizar barra de progreso
        this.load.on('progress', (value) => {
            progressBar.clear();
            progressBar.fillStyle(0xffffff, 1);
            progressBar.fillRect(width/2-150, 280, 300 * value, 30);
            percentText.setText(parseInt(value * 100) + '%');
        });
        
        this.load.on('fileprogress', (file) => {
            assetText.setText('Cargando: ' + file.key);
        });
        
        this.load.on('complete', () => {
            progressBar.destroy();
            progressBox.destroy();
            loadingText.destroy();
            percentText.destroy();
            assetText.destroy();
        });
        
        // Cargar assets
        this.loadAssets();
    }
    
    loadAssets() {
        // Cargar imágenes
        this.load.image('background', 'assets/images/amazon_background.png');
        this.load.image('slot_machine', 'assets/images/slot_machine.png');
        this.load.image('spinBtn', 'assets/images/spin_btn.png');
        this.load.image('banana', 'assets/images/banana.png');
        this.load.image('monkey', 'assets/images/monkey.png');
        this.load.image('treasure', 'assets/images/treasure.png');
        this.load.image('leaf', 'assets/images/leaf.png');
        this.load.image('coconut', 'assets/images/coconut.png');
        this.load.image('flower', 'assets/images/red_flower.png');
        this.load.image('diamond', 'assets/images/diamond.png');
        this.load.image('horseshoe', 'assets/images/horseshoe.png');
        this.load.image('title', 'assets/images/title.png');
        this.load.image('treasure_decorative', 'assets/images/treasure_decorative.png');
        this.load.image('leafs_decorative', 'assets/images/leafs_decorative.png');
       
        // Cargar spritesheets
        this.load.spritesheet('monkeySmallWin', 'assets/sprites/monkey_smallwin_sprite.png', { 
            frameWidth: 256, 
            frameHeight: 256 
        });
        this.load.spritesheet('lightning', 'assets/sprites/lightning_sprite.png', { 
            frameWidth: 117, 
            frameHeight: 128 
        });
        this.load.spritesheet('monkeyGun', 'assets/sprites/monkey_gun_sprite.png', { 
            frameWidth: 133, 
            frameHeight: 128 
        });
        this.load.image('plane', 'assets/images/plane.png');
        this.load.image('shine', 'assets/images/shine_bar.png');
        this.load.image('coin', 'assets/images/coin.png');
        this.load.image('winText', 'assets/images/win_text.png');
        
        // Cargar audio
        this.load.audio('monkey_sound', 'assets/audio/monkey_sound.wav');
        this.load.audio('plane_sound', 'assets/audio/plane_sound.mp3');
        //this.load.audio('banana_splat_sound', 'assets/audio/banana_splat_sound.mp3');
        this.load.audio('coins_sound', 'assets/audio/coins_sound.wav');
        this.load.audio('spin_sound', 'assets/audio/spin_sound.mp3');
        this.load.audio('amazon_ambience', 'assets/audio/amazon_ambience.mp3');
    }
    
    create() {
        this.scene.start('GameScene');
    }
}

// Escena del menú principal
class MenuScene extends Phaser.Scene {
    constructor() {
        super({ key: 'MenuScene' });
    }
    
    create() {
        // Fondo amazónico que cubra toda la pantalla
        this.createFullScreenBackground();
        
        // Título del juego
        const title = this.add.text(640, 200, '🍌 CHEEKY MONKEY 🍌', {
            fontSize: '48px',
            fill: '#ffd700',
            stroke: '#000000',
            strokeThickness: 4,
            fontFamily: 'Arial'
        });
        title.setOrigin(0.5);
        
        // Subtítulo
        const subtitle = this.add.text(640, 280, 'Amazonic Slot with Cheecky Monkey', {
            fontSize: '24px',
            fill: '#ffffff',
            fontFamily: 'Arial'
        });
        subtitle.setOrigin(0.5);
        
        // Botón de jugar
        const playButton = this.add.text(640, 400, '🎰 PLAY 🎰', {
            fontSize: '32px',
            fill: '#00ff00',
            stroke: '#000000',
            strokeThickness: 2,
            fontFamily: 'Arial'
        });
        playButton.setOrigin(0.5);
        playButton.setInteractive();
        
        // Efectos hover
        playButton.on('pointerover', () => {
            playButton.setScale(1.1);
            playButton.setFill('#ffff00');
        });
        
        playButton.on('pointerout', () => {
            playButton.setScale(1);
            playButton.setFill('#00ff00');
        });
        
        playButton.on('pointerdown', () => {
            this.scene.start('GameScene');
        });
        
        // Efectos de partículas para ambiente
        this.createParticleEffects();
    }
    
    createParticleEffects() {
        // Efecto simplificado de hojas cayendo (sin partículas por ahora)
        // TODO: Implementar con la nueva API de partículas de Phaser 3.70.0
        console.log('Efectos de partículas deshabilitados temporalmente');
    }
    
    // Crear fondo que cubra toda la pantalla (equivalente a background-size: cover)
    createFullScreenBackground() {
        // Obtener dimensiones del juego
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const background = this.add.image(0, 0, 'background');
        background.setOrigin(0, 0);
        const scaleX = gameWidth / background.width;
        const scaleY = gameHeight / background.height;
        // Usar la escala más grande para asegurar que cubra toda la pantalla
        const scale = Math.max(scaleX, scaleY);
        background.setScale(scale);
        // Centrar la imagen en la pantalla
        background.setPosition(
            (gameWidth - (background.width * scale)) / 2,
            (gameHeight - (background.height * scale)) / 2
        );
        
        // Asegurar que esté detrás de todo
        background.setDepth(-1000);
    }
}

// Escena principal del juego
class GameScene extends Phaser.Scene {
    constructor() {
        super({ key: 'GameScene' });
        this.symbols = ['banana', 'monkey', 'treasure', 'leaf', 'coconut', 'flower', 'diamond', 'horseshoe'];
        this.reels = [];
        this.isSpinning = false;
        this.balance = 1000;
        this.bet = 10;
        this.winAmount = 0;
        
        // Obtener información del dispositivo
        this.deviceInfo = null;
        this.isCountingWin = false;
        
        // Configuración responsive del diseño
        this.reelCount = 6;
        this.symbolsPerReel = 5;
        this.visibleSymbols = 5; // Símbolos visibles por reel
    }
    
    create() {
        // Obtener información del dispositivo
        this.deviceInfo = this.registry.get('deviceInfo');
        
        // Fondo que cubra toda la pantalla (background-size: cover)
        this.createFullScreenBackground();
        
        // Crear elementos decorativos con posiciones responsive
        this.createDecorations();
        
        // Botón de pantalla completa (esquina superior derecha)
        this.createFullscreenButton();
        
        this.createReels();
        
        this.createUI();

        // Control por gesto: deslizar hacia arriba para hacer PLAY en mobile
        if (this.deviceInfo?.isMobile) {
            this.enableSwipeToSpin();
        } else {
            // Atajo en desktop: tecla ESPACIO para iniciar spin
            this.enableSpaceToSpin();
        }
        
        this.ambientSound = this.sound.add('amazon_ambience', { loop: true, volume: 0.3 });
        
        this.ambientSound.play();
        
        //this.createLightEffects();
        
        this.createAnimations();
    }

    // Activar gesto de deslizar hacia arriba para iniciar el spin (estilo TikTok)
    enableSwipeToSpin() {
        this.swipeStartX = null;
        this.swipeStartY = null;
        this.swipeStartTime = 0;
        
        this.input.on('pointerdown', (pointer) => {
            // Solo considerar un dedo
            if (pointer?.wasTouch || pointer.pointerType === 'touch') {
                this.swipeStartX = pointer.x;
                this.swipeStartY = pointer.y;
                this.swipeStartTime = this.time.now;
            }
        });
        
        this.input.on('pointerup', (pointer) => {
            if (this.swipeStartY == null) return;
            const endX = pointer.x;
            const endY = pointer.y;
            const dx = endX - this.swipeStartX;
            const dy = endY - this.swipeStartY; // hacia arriba => negativo
            const dt = this.time.now - this.swipeStartTime;
            
            // Umbrales para swipe hacia arriba
            const minDistance = 80; // px
            const maxSideDrift = 70; // px
            const maxDuration = 700; // ms
            const isUpSwipe = (dy < -minDistance) && (Math.abs(dx) < maxSideDrift) && (dt <= maxDuration);
            
            if (isUpSwipe) {
                if (!this.isSpinning && !this.isCountingWin && this.balance >= this.bet) {
                    // Feedback visual en el botón si existe
                    if (this.spinButtonContainer) {
                        this.spinButtonClickEffect();
                    }
                    this.spin();
                }
            }
            
            // Reset
            this.swipeStartX = null;
            this.swipeStartY = null;
            this.swipeStartTime = 0;
        });
    }

    // Activar tecla SPACE para iniciar el spin en desktop
    enableSpaceToSpin() {
        this.input.keyboard.on('keydown-SPACE', (event) => {
            if (!this.deviceInfo?.isMobile) {
                if (!this.isSpinning && !this.isCountingWin && this.balance >= this.bet) {
                    event?.preventDefault?.();
                    if (this.spinButtonContainer) {
                        this.spinButtonClickEffect();
                    }
                    this.spin();
                }
            }
        });
    }

    // Crear botón para alternar pantalla completa
    createFullscreenButton() {
        const gameWidth = this.cameras.main.width;
        const isMobile = this.deviceInfo?.isMobile || false;
        // Tamaño/padding optimizados para mobile (área táctil más grande)
        const btnSize = isMobile ? 56 : 44; // lado del botón cuadrado
        const padding = isMobile ? 18 : 16; // separación al borde
        const x = gameWidth - padding -10 ;
        const y = padding + (isMobile ? 4 : 0)   + 10;
        
        this.fullscreenBtnContainer = this.add.container(x, y);
        this.fullscreenBtnContainer.setDepth(2000);
        this.fullscreenBtnContainer.setScrollFactor(0);
        
        const bg = this.add.graphics();
        bg.fillStyle(0x000000, isMobile ? 0.6 : 0.5);
        const radius = isMobile ? 5 : 5;
        // Dibujar botón cuadrado con bordes redondeados centrado en (0,0)
        bg.fillRoundedRect(-btnSize / 2, -btnSize / 2, btnSize, btnSize, radius);
        bg.lineStyle(isMobile ? 3 : 2, 0xffffff, 0.9);
        bg.strokeRoundedRect(-btnSize / 2, -btnSize / 2, btnSize, btnSize, radius);
        this.fullscreenBtnContainer.add(bg);
        
        const icon = this.add.text(0, 0, '⛶', {
            fontSize: isMobile ? '22px' : '22px',
            fill: '#ffffff',
            stroke: '#000000',
            strokeThickness: isMobile ? 3 : 2,
            fontFamily: 'Arial',
            fontWeight: 'bold'
        });
        icon.setOrigin(0.5);
        this.fullscreenBtnContainer.add(icon);
        
        // Área interactiva rectangular (ligeramente mayor en mobile)
        const hitGrow = isMobile ? 8 : 0;
        const hitRect = new Phaser.Geom.Rectangle(-btnSize / 2 - hitGrow / 2, -btnSize / 2 - hitGrow / 2, btnSize + hitGrow, btnSize + hitGrow);
        this.fullscreenBtnContainer.setInteractive(hitRect, Phaser.Geom.Rectangle.Contains);
        
        // Hover y click
        if (!isMobile) {
            this.fullscreenBtnContainer.on('pointerover', () => {
                this.tweens.add({ targets: this.fullscreenBtnContainer, scaleX: 1.08, scaleY: 1.08, duration: 120, ease: 'Power2' });
            });
            this.fullscreenBtnContainer.on('pointerout', () => {
                this.tweens.add({ targets: this.fullscreenBtnContainer, scaleX: 1, scaleY: 1, duration: 120, ease: 'Power2' });
            });
        }
        this.fullscreenBtnContainer.on('pointerdown', () => {
            if (this.scale.isFullscreen) {
                this.scale.stopFullscreen();
            } else {
                this.scale.startFullscreen();
            }
            // Pequeño feedback visual
            this.tweens.add({ targets: this.fullscreenBtnContainer, scaleX: 0.92, scaleY: 0.92, duration: 90, yoyo: true, ease: 'Power2' });
        });
        
        // Reposicionar si cambia el tamaño
        this.scale.on('resize', (gameSize) => {
            const w = gameSize.width;
            this.fullscreenBtnContainer.setPosition(w - padding - 10, padding + (isMobile ? 4 : 0) + 10);
        });
    }
    
    // Crear elementos decorativos responsive
    createDecorations() {
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const isMobile = this.deviceInfo?.isMobile || false;
        
        // Título
        const titleScale = isMobile ? 0.3 : 0.3;
        const titleX = isMobile ? gameWidth * 0.5 : 80;
        const titleY = isMobile ? gameHeight * 0.1 : 80;
        this.add.image(titleX, titleY, 'title').setScale(titleScale).setRotation(-0.1);
        
        // Máquina de slot (centrada)
        const slotMachineX = gameWidth / 2-10;
        const slotMachineY = gameHeight / 2- (isMobile ? 42 : 40);
        const slotMachineScale = isMobile ? 0.96: 0.95;
        this.add.image(slotMachineX, slotMachineY, 'slot_machine').setScale(slotMachineScale);
        
        // Elementos decorativos (solo en desktop/tablet)
        if (!isMobile) {
            this.add.image(gameWidth - 100, gameHeight - 70, 'treasure_decorative');
            this.add.image(gameWidth - 80, gameHeight - 50, 'leafs_decorative').setScale(0.8).setRotation(-0.3);
            this.add.image(100, gameHeight - 50, 'coconut').setScale(1.2);
            this.add.image(80, gameHeight - 50, 'leafs_decorative').setScale(0.8).setRotation(-0.3);
        }else{
            this.add.image(10, gameHeight - 100, 'treasure_decorative').setScale(0.5);
        }
    }
    
    createReels() {
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const isMobile = this.deviceInfo?.isMobile || false;
        
        // Ajustar dimensiones según el dispositivo
        const reelWidth = isMobile ? 65 : 141;
        const reelHeight = isMobile ? 420 : 420;
        const startX = isMobile ? gameWidth * 0.1 : 275;
        const startY = isMobile ? gameHeight * 0.21 : 155;
        
        // Crear contenedor principal para todos los reels
        this.reelsContainer = this.add.container(0, 0);
        
        for (let i = 0; i < this.reelCount; i++) {
            const reel = this.add.container(startX + i * reelWidth, startY);
            this.reels.push(reel);
            this.reelsContainer.add(reel);
            
            // Crear muchos símbolos para efecto de giro continuo
            for (let j = 0; j < 5; j++) { // Ajustado para 5 símbolos visibles
                const symbol = this.add.image(0, j * (reelHeight / this.visibleSymbols), this.symbols[Math.floor(Math.random() * this.symbols.length)]);
                const symbolScale = isMobile ? 0.4 : 0.5; // Escala más pequeña en móviles
                symbol.setScale(symbolScale);
                symbol.setOrigin(0.5, 0.5); // Centrar el símbolo
                reel.add(symbol);
            }
        }
        
        // Crear viewport/máscara para simular que los reels giran dentro de la máquina
        this.createSlotMachineViewport();
        
        // Debug completo de símbolos
        this.debugSymbols();
    }
    
    createSlotMachineViewport() {
         // Crear máscara que simule el viewport de la máquina de slot
         const maskGraphics = this.add.graphics();
         
         const gameWidth = this.cameras.main.width;
         const gameHeight = this.cameras.main.height;
         const isMobile = this.deviceInfo?.isMobile || false;
         
         // Definir las dimensiones del viewport responsive
         let viewportX, viewportY, viewportWidth, viewportHeight;
         
         if (isMobile) {
             viewportX = gameWidth * 0.01; // 10% del ancho
             viewportY = gameHeight * 0.18; // 25% de la altura
             viewportWidth = gameWidth * 0.98; // 80% del ancho
             viewportHeight = gameHeight * 0.555; // 30% de la altura
         } else {
             viewportX = 205; // Posición X del primer reel
             viewportY = 125; // Posición Y del primer reel (ajustado para 5 símbolos)
             viewportWidth = 141 * this.reelCount; // Ancho total de los 6 reels
             viewportHeight = 394; // Alto del área visible de los reels (ajustado para 5 símbolos)
         }
         
         // Crear la máscara rectangular - IMPORTANTE: usar 0x000000 (negro) para la máscara
         //maskGraphics.fillStyle(0x000000); // ACTIVAR LA MÁSCARA
         maskGraphics.fillRect(viewportX, viewportY, viewportWidth, viewportHeight);
         
         // Aplicar la máscara al contenedor de reels
         const mask = maskGraphics.createGeometryMask();
         this.reelsContainer.setMask(mask);
         
         // Crear borde visual para el viewport (opcional, para debug)
         if(!isMobile){
         this.viewportBorder = this.add.graphics();
         this.viewportBorder.lineStyle(1, 0x000000, 0.5);
         this.viewportBorder.strokeRect(viewportX, viewportY, viewportWidth, viewportHeight);
         }
         // Crear líneas divisorias entre reels para mejor visualización
         this.viewportDividers = [];
         for (let i = 1; i < this.reelCount; i++) {
            const w_ = isMobile ? 65 : 141;
             const dividerX = viewportX + (i * w_);
             const dividerRight = this.add.graphics();
             const dividerLeft = this.add.graphics();
             const divider = this.add.graphics();

             divider.lineStyle( isMobile ? 1 : 2, 0x8b6733, 1);
             divider.beginPath();
             divider.moveTo(dividerX, viewportY);
             divider.lineTo(dividerX, viewportY + viewportHeight);
             divider.strokePath();

             dividerRight.lineStyle(isMobile ? 1 : 4, 0xc79e57, 0.5);
             dividerRight.beginPath();
             dividerRight.moveTo(dividerX-2, viewportY);
             dividerRight.lineTo(dividerX-2, viewportY + viewportHeight);
             dividerRight.strokePath();

             dividerLeft.lineStyle(isMobile ? 1 : 4, 0xc79e57, 0.5);
             dividerLeft.beginPath();
             dividerLeft.moveTo(dividerX+2, viewportY);
             dividerLeft.lineTo(dividerX+2, viewportY + viewportHeight);
             dividerLeft.strokePath();
            
             this.viewportDividers.push(divider, dividerRight, dividerLeft);
         }
         
     }
    
    // Método para ajustar el viewport si es necesario
    adjustViewport(x, y, width, height) {
        if (this.reelsContainer && this.reelsContainer.mask) {
            // Remover máscara anterior
            this.reelsContainer.setMask(null);
            
            // Crear nueva máscara
            const maskGraphics = this.add.graphics();
            maskGraphics.fillStyle(0xffffff);
            maskGraphics.fillRect(x, y, width, height);
            
            // Aplicar nueva máscara
            const mask = maskGraphics.createGeometryMask();
            this.reelsContainer.setMask(mask);
            
            console.log('Viewport ajustado a:', { x, y, width, height });
        }
    }
    
    // Método para ocultar/mostrar el borde del viewport
    toggleViewportBorder(visible = false) {
        // Buscar y ocultar/mostrar todos los elementos gráficos del viewport
        this.children.list.forEach(child => {
            if (child.type === 'Graphics' && child !== this.reelsContainer) {
                child.setVisible(visible);
            }
        });
    }
    
    // Método de debug para verificar símbolos
    debugSymbols() {
        console.log('=== DEBUG SÍMBOLOS ===');
        console.log('Contenedor de reels:', this.reelsContainer);
        console.log('Máscara aplicada:', this.reelsContainer.mask);
        
        this.reels.forEach((reel, reelIndex) => {
            const symbols = reel.getAll();
            console.log(`Reel ${reelIndex}:`, {
                position: { x: reel.x, y: reel.y },
                symbolsCount: symbols.length,
                visible: reel.visible,
                alpha: reel.alpha
            });
            
            symbols.forEach((symbol, symbolIndex) => {
                if (symbolIndex < 3) { // Solo mostrar los primeros 3
                    console.log(`  Símbolo ${symbolIndex}:`, {
                        texture: symbol.texture ? symbol.texture.key : 'NO TEXTURE',
                        position: { x: symbol.x, y: symbol.y },
                        visible: symbol.visible,
                        alpha: symbol.alpha,
                        scale: { x: symbol.scaleX, y: symbol.scaleY }
                    });
                }
            });
        });
    }
    
    // Crear animaciones
    createAnimations() {
        // Animación del mono corriendo
        //1. Mono
        this.anims.create({
            key: 'monkeyWink',
            frames: this.anims.generateFrameNumbers('monkeySmallWin', { start: 0, end: 1 }),
            frameRate: 6,
            repeat: 0
        });
        
        // Animación del rayo
        this.anims.create({
            key: 'lightning',
            frames: this.anims.generateFrameNumbers('lightning', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: 0,
            hideOnComplete: true
        });
        
        // Animación del avión
        this.anims.create({
            key: 'planeFly',
            frames: this.anims.generateFrameNumbers('plane', { start: 0, end: 2 }),
            frameRate: 8,
            repeat: -1 // Repetir infinitamente mientras vuela
        });
        
        // Animación del mono con ametralladora
        this.anims.create({
            key: 'monkeyShoot',
            frames: this.anims.generateFrameNumbers('monkeyGun', { start: 0, end: 1 }),
            frameRate: 10,
            repeat: -1 // Repetir infinitamente mientras dispara
        });
       
    }
    
    // Crear fondo que cubra toda la pantalla (equivalente a background-size: cover)
    createFullScreenBackground() {
        // Obtener dimensiones del juego
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        
        // Crear imagen de fondo
        const background = this.add.image(0, 0, 'background');
        
        // Centrar la imagen
        background.setOrigin(0, 0);
        
        // Calcular la escala necesaria para cubrir toda la pantalla
        const scaleX = gameWidth / background.width;
        const scaleY = gameHeight / background.height;
        
        // Usar la escala más grande para asegurar que cubra toda la pantalla
        const scale = Math.max(scaleX, scaleY);
        
        // Aplicar la escala
        background.setScale(scale);
        
        // Centrar la imagen en la pantalla
        background.setPosition(
            (gameWidth - (background.width * scale)) / 2,
            (gameHeight - (background.height * scale)) / 2
        );
        
        // Asegurar que esté detrás de todo
        background.setDepth(-1000);
        
    }
    
    // Botón de spin basado en imagen con animación y "..." durante el spin
    createSpinButton(buttonX = 700, buttonY = 600, buttonRadius = 80) {
        const isMobile = this.deviceInfo?.isMobile || false;
        const size = isMobile ? 90 : 110;
        
        this.spinButtonContainer = this.add.container(buttonX, buttonY);
        
        const btn = this.add.image(0, 0, 'spinBtn');
        btn.setDisplaySize(size, size);
        btn.setInteractive({ useHandCursor: true });
        this.spinButtonContainer.add(btn);
        
        // Texto de puntos sobre el botón durante el giro
        this.spinDotsText = this.add.text(0, 0, '', {
            fontSize: isMobile ? '18px' : '20px',
            fill: '#ffffff',
            stroke: '#000000',
            strokeThickness: 3,
            fontFamily: 'Arial',
            fontWeight: 'bold'
        });
        this.spinDotsText.setOrigin(0.5);
        this.spinDotsText.setDepth(10);
        this.spinButtonContainer.add(this.spinDotsText);
        
        btn.on('pointerover', () => {
            if (this.isSpinning) return;
            this.tweens.add({ targets: this.spinButtonContainer, scaleX: 1.05, scaleY: 1.05, duration: 120, ease: 'Power2' });
        });
        btn.on('pointerout', () => {
            if (this.isSpinning) return;
            this.tweens.add({ targets: this.spinButtonContainer, scaleX: 1, scaleY: 1, duration: 120, ease: 'Power2' });
        });
        btn.on('pointerdown', () => {
            if (!this.isSpinning && this.balance >= this.bet) {
                this.spinButtonClickEffect();
                this.spin();
            }
        });
    }
    
    // Mostrar animación de líneas ganadoras (actualizado para el nuevo sistema)
    showWinningLines(winGroups) {
        console.log('🎯 Mostrando grupos ganadores:', winGroups);
        
        // Crear contenedor para los grupos ganadores
        this.winningLinesContainer = this.add.container(0, 0);
        
        winGroups.forEach((winGroup, index) => {
            this.animateWinningGroup(winGroup, index * 500);
        });
        
        // Sonido de victoria inmediato
        //this.sound.play('coins_sound');
    }
    
    // Animar grupo ganador (nuevo método para símbolos adyacentes)
    animateWinningGroup(winGroup, delay) {
        const { symbol, positions, count } = winGroup;
        
        
        // Resaltar todos los símbolos ganadores
        positions.forEach((pos, index) => {
            const symbolObj = this.reels[pos.reel].getAt(pos.symbol);
            if (symbolObj) {
                this.highlightWinningSymbol(symbolObj, delay + 200 + (index * 100));
            }
        });
    }
    

    
    // Resaltar símbolo ganador
    highlightWinningSymbol(symbol, delay) {
        // FASE 1: Efecto de rayo que pasa por el símbolo
        this.createLightningEffect(symbol, delay);
        
        // FASE 2: Efecto de explosión después del rayo
        this.tweens.add({
            targets: symbol,
            scaleX: 1.5,
            scaleY: 1.5,
            alpha: 0,
            duration: 400,
            delay: delay + 300, // Esperar a que termine el rayo
            ease: 'Power2',
            onComplete: () => {
                // Restaurar el símbolo después de la explosión
                symbol.setScale(0.5);
                symbol.setAlpha(1);
            }
        });
        
        // Efecto de partículas de explosión (usar posición absoluta como en el rayo)
        const absPos = this.getSymbolAbsolutePosition(symbol);
        this.createExplosionParticles(absPos.x, absPos.y, delay + 300);
        
    }
    
    // Crear efecto de rayo que pasa por el símbolo
    createLightningEffect(symbol, delay) {
        const isMobile = this.deviceInfo?.isMobile || false;
        // Encontrar a qué reel pertenece este símbolo
        let reelIndex = -1;
        let symbolIndex = -1;
        
        this.reels.forEach((reel, rIndex) => {
            const symbols = reel.getAll();
            symbols.forEach((s, sIndex) => {
                if (s === symbol) {
                    reelIndex = rIndex;
                    symbolIndex = sIndex;
                }
            });
        });
        
        // Calcular la posición absoluta basada en el reel y símbolo
        const reelWidth = 141; // Ancho de cada reel
        const startX = 275; // Posición X del primer reel
        const startY = 150; // Posición Y del primer reel
        const symbolHeight = 394 / this.visibleSymbols; // Altura de cada símbolo
        
        const absoluteX = startX + (reelIndex * reelWidth) + (isMobile ? 20 : 0);
        const absoluteY = startY + (symbolIndex * symbolHeight) ;
        
        
        // Crear el sprite del rayo en la posición absoluta
        const lightning = this.add.sprite(absoluteX, absoluteY, 'lightning');
        lightning.setScale(0.25);
        lightning.setOrigin(0.5, 0.5);
        
        // Reproducir la animación del rayo
        lightning.play('lightning');
        
        // Destruir el rayo después de que termine la animación
        lightning.once('animationcomplete', () => {
            lightning.destroy();
        });
        
        // Efecto de destello en el símbolo
        this.tweens.add({
            targets: symbol,
            alpha: 0.8,
            duration: 150,
            delay: delay,
            yoyo: true,
            repeat: 2,
            onComplete: () => {
                symbol.setAlpha(1);
            }
        });
        
        // Agregar al contenedor
        this.winningLinesContainer.add(lightning);
    }
    
    // Obtener posición absoluta del símbolo (misma lógica que el rayo)
    getSymbolAbsolutePosition(symbol) {
        // Encontrar a qué reel y posición pertenece
        let reelIndex = -1;
        let symbolIndex = -1;
        this.reels.forEach((reel, rIndex) => {
            const symbols = reel.getAll();
            symbols.forEach((s, sIndex) => {
                if (s === symbol) {
                    reelIndex = rIndex;
                    symbolIndex = sIndex;
                }
            });
        });
        // Usar las mismas constantes que en createLightningEffect
        const reelWidth = 141;
        const startX = 275;
        const startY = 150;
        const symbolHeight = 394 / this.visibleSymbols;
        return {
            x: startX + (reelIndex * reelWidth),
            y: startY + (symbolIndex * symbolHeight)
        };
    }
    
    // Crear partículas de explosión simples
    createExplosionParticles(x, y, delay) {
        for (let i = 0; i < 6; i++) {
            const particle = this.add.graphics();
            particle.fillStyle(0xffff00, 1);
            particle.fillCircle(0, 0, 2);
            
            const angle = (i / 6) * Math.PI * 2;
            const speed = 30 + Math.random() * 30;
            
            particle.x = x;
            particle.y = y;
            
            this.tweens.add({
                targets: particle,
                x: particle.x + Math.cos(angle) * speed,
                y: particle.y + Math.sin(angle) * speed,
                alpha: 0,
                scaleX: 0,
                scaleY: 0,
                duration: 500,
                delay: delay,
                ease: 'Power2',
                onComplete: () => {
                    particle.destroy();
                }
            });
        }
    }
    
    // Deshabilitar botón de spin durante el giro
    disableSpinButton() {
        if (this.spinButtonContainer) {
            this.isSpinning = true;
            this.spinButtonContainer.setAlpha(0.95);
            const img = this.spinButtonContainer.getAt(0);
            if (img && img.disableInteractive) img.disableInteractive();
            // Iniciar animación de puntos sobre el botón
            this.startDotsLoop();
        }
    }
    
    // Habilitar botón de spin después del giro
    enableSpinButton() {
        if (this.spinButtonContainer) {
            this.isSpinning = false;
            this.spinButtonContainer.setAlpha(1);
            const img = this.spinButtonContainer.getAt(0);
            if (img && img.setInteractive) img.setInteractive({ useHandCursor: true });
            this.stopDotsLoop();
            if (this.spinDotsText) this.spinDotsText.setText('');
        }
    }
    
    // Efecto hover del botón de spin
    spinButtonHoverEffect(isHovering) {
        if (isHovering) {
            // Escalar ligeramente y cambiar color
            this.tweens.add({
                targets: this.spinButtonContainer,
                scaleX: 1.1,
                scaleY: 1.1,
                duration: 200,
                ease: 'Power2'
            });
            
            // Cambiar color del círculo central a dorado brillante
            const centerCircle = this.spinButtonContainer.getAt(2);
            centerCircle.clear();
            centerCircle.fillStyle(0x000000, 0.9);
            centerCircle.fillCircle(0, 0, 60);
        } else {
            // Volver al tamaño normal
            this.tweens.add({
                targets: this.spinButtonContainer,
                scaleX: 1,
                scaleY: 1,
                duration: 200,
                ease: 'Power2'
            });
            
            // Restaurar color original
            const centerCircle = this.spinButtonContainer.getAt(2);
            centerCircle.clear();
            centerCircle.fillStyle(0x000000, 0.9);
            centerCircle.fillCircle(0, 0, 60);
        }
    }
    
    // Efecto click del botón de spin
    spinButtonClickEffect() {
        // Animación de presión rápida y pequeño giro
        this.tweens.add({ targets: this.spinButtonContainer, scaleX: 0.92, scaleY: 0.92, angle: -5, duration: 90, ease: 'Power2', yoyo: true });
        this.createSpinButtonGlow();
        
        // Sonido de click
        this.sound.play('spin_sound');
    }
    
    // Crear efecto de brillo en el botón
    createSpinButtonGlow() {
        const glow = this.add.graphics();
        glow.fillStyle(0xffffff, 0.15);
        glow.fillCircle(this.spinButtonContainer.x, this.spinButtonContainer.y, 10);
        this.tweens.add({ targets: glow, scaleX: 3, scaleY: 3, alpha: 0, duration: 400, ease: 'Power2', onComplete: () => glow.destroy() });
    }
    
    // Bucle de puntos "..." mientras está girando
    startDotsLoop() {
        if (!this.spinDotsText) return;
        this.spinDotsText.setText('.');
        let step = 1;
        if (this.dotsTimer) {
            this.dotsTimer.remove();
            this.dotsTimer = null;
        }
        this.dotsTimer = this.time.addEvent({
            delay: 250,
            loop: true,
            callback: () => {
                step = (step % 3) + 1;
                this.spinDotsText.setText('.'.repeat(step));
            }
        });
    }
    
    stopDotsLoop() {
        if (this.dotsTimer) {
            this.dotsTimer.remove();
            this.dotsTimer = null;
        }
        if (this.spinDotsText) this.spinDotsText.setText('');
    }
    

    
    createUI() {
         // Crear barra inferior
         this.createBottomBar();
         
         // Texto de ganancias (se mostrará solo cuando haya ganancia)
         const gameWidth = this.cameras.main.width;
         const gameHeight = this.cameras.main.height;
         const isMobile = this.deviceInfo?.isMobile || false;
         
         const winTextX = gameWidth / 2;
         const winTextY = isMobile ? gameHeight -50 : gameHeight -40;
         const winTextSize = isMobile ? '20px' : '28px';
         
         this.winText = this.add.text(winTextX, winTextY, '', {
             fontSize: winTextSize,
             fill: '#ffd700',
             stroke: '#000000',
             strokeThickness: 3,
             fontFamily: 'Arial',
             fontWeight: 'bold'
         });
         this.winText.setOrigin(0.5);
         this.winText.setVisible(false);
     }
     
     // Crear barra inferior elegante
     createBottomBar() {
         const gameWidth = this.cameras.main.width;
         const gameHeight = this.cameras.main.height;
         const isMobile = this.deviceInfo?.isMobile || false;
         
         const barHeight = isMobile ? 100 : 70;
         const barY = gameHeight - barHeight;
         
         // Fondo de la barra (negro con transparencia)
         const barBackground = this.add.graphics();
         barBackground.fillStyle(0x000000, 0.8);
         barBackground.fillRect(0, barY, gameWidth, barHeight);
         
         // Borde superior de la barra
         const barBorder = this.add.graphics();
         barBorder.lineStyle(2, 0x333333, 1);
         barBorder.beginPath();
         barBorder.moveTo(0, barY);
         barBorder.lineTo(gameWidth, barY);
         barBorder.strokePath();
         
         // SECCIÓN IZQUIERDA: Balance y Apuesta
         this.createLeftSection(barY, barHeight);
         
         // SECCIÓN CENTRO
         this.createCenterSection(barY, barHeight);
         
         // SECCIÓN DERECHA: Controles de apuesta
         this.createRightSection(barY, barHeight);
     }
     
     // Crear sección izquierda (Balance y Apuesta)
     createLeftSection(barY, barHeight) {
         const gameWidth = this.cameras.main.width;
         const isMobile = this.deviceInfo?.isMobile || false;
         
         const leftX = isMobile ? gameWidth * 0.01 : 50;
         const centerY = barY + (barHeight / 2);
         const fontSize = isMobile ? '24px' : '32px';
         const labelSize = isMobile ? '12px' : '14px';
         
         
         // Balance
         this.balanceText = this.add.text(leftX+20, centerY - (isMobile ? 55 : 30), `$${this.balance}`, {
             fontSize: fontSize,
             fill: '#ffd700',
             stroke: '#000000',
             strokeThickness: 3,
             fontFamily: 'Arial',
             fontWeight: 'bold'
         });
         
         // Etiqueta "BALANCE"
         const balanceLabel = this.add.text(leftX+25, centerY-(isMobile ? 32 : -10), 'BALANCE', {
             fontSize: labelSize,
             fill: '#ffffff',
             fontFamily: 'Arial',
             fontWeight: 'bold'
         });
         
         // Botón reducir apuesta
         const betDownX = isMobile ? leftX + 5 : leftX + 170;
         const betDownY = isMobile ? centerY + 5 : centerY + 10;
         const betDownButton = this.createBetButton(betDownX, betDownY, '▼', -10);
         
         // Apuesta
         const betX = isMobile ? leftX + 25 : leftX + 200;
         const betY = isMobile ? centerY -15 : centerY - 20;
         this.betText = this.add.text(betX, betY, `$${this.bet}`, {
             fontSize: fontSize,
             fill: '#ffffff',
             stroke: '#000000',
             strokeThickness: 3,
             fontFamily: 'Arial',
             fontWeight: 'bold'
         });
         
         // Etiqueta "APUESTA"
         const betLabel = this.add.text(betX, betY + (isMobile ? 25 : 35), 'APUESTA', {
             fontSize: labelSize,
             fill: '#ffffff',
             fontFamily: 'Arial',
             fontWeight: 'bold'
         });

        // Botón aumentar apuesta
        const betUpX = isMobile ? leftX + 100 : leftX + 290;
        const betUpY = isMobile ? centerY +5 : centerY + 10;
        const betUpButton = this.createBetButton(betUpX, betUpY, '▲', 10);

     }
     
     // Crear sección central (Botón)
     createCenterSection(barY, barHeight) {
         const gameWidth = this.cameras.main.width;
         const isMobile = this.deviceInfo?.isMobile || false;
         
         const centerX = gameWidth / 2;
         const centerY = barY + (barHeight / 2);
         const labelSize = isMobile ? '12px' : '14px';

         const winLabel = this.add.text(centerX-30, centerY + (isMobile ? 10 : 10), 'GANANCIA', {
            fontSize: labelSize,
            fill: '#ffffff',
            fontFamily: 'Arial',
            fontWeight: 'bold'
        });
     }
     
     // Crear sección derecha (Controles de apuesta)
     createRightSection(barY, barHeight) {
        const gameWidth = this.cameras.main.width;
        const isMobile = this.deviceInfo?.isMobile || false;
        
        const rightX = isMobile ? gameWidth - 50 : gameWidth - 150;
        const centerY = barY + (barHeight / 2) - (isMobile ? 20 : 0);
        const buttonRadius = isMobile ? 50 : 70;
         
        // Botón SPIN circular (más grande y centrado)
        this.createSpinButton(rightX, centerY, buttonRadius);
        
         
     }
     
         // Crear botón de apuesta
    createBetButton(x, y, symbol, amount) {
        const isMobile = this.deviceInfo?.isMobile || false;
        
        // Crear contenedor en la posición especificada
        const buttonContainer = this.add.container(x, y);
        
        const buttonRadius = isMobile ? 20 : 25;
        const fontSize = isMobile ? '16px' : '20px';
        
        // Fondo del botón (círculo blanco con transparencia) - coordenadas relativas al contenedor
        const buttonBackground = this.add.graphics();
        buttonBackground.fillStyle(0x000000, 0.9);
        buttonBackground.fillCircle(0, 0, buttonRadius);
        buttonContainer.add(buttonBackground);
        
        // Borde del botón - coordenadas relativas al contenedor
        const buttonBorder = this.add.graphics();
        buttonBorder.lineStyle(2, 0x333333, 1);
        buttonBorder.strokeCircle(0, 0, buttonRadius);
        buttonContainer.add(buttonBorder);
        
        // Símbolo del botón - coordenadas relativas al contenedor
        const buttonSymbol = this.add.text(0, 0, symbol, {
            fontSize: fontSize,
            fill: '#ffd700',
            fontFamily: 'Arial',
            fontWeight: 'bold'
        });
        buttonSymbol.setOrigin(0.5);
        buttonContainer.add(buttonSymbol);
        
        // Hacer interactivo
        buttonContainer.setInteractive(new Phaser.Geom.Circle(0, 0, buttonRadius), Phaser.Geom.Circle.Contains);
        
        // Efectos hover
        buttonContainer.on('pointerover', () => {
            buttonBackground.clear();
            buttonBackground.fillStyle(0x333333, 0.9);
            buttonBackground.fillCircle(0, 0, buttonRadius);
            buttonSymbol.setFill('#ffff00');
        });
        
        buttonContainer.on('pointerout', () => {
            buttonBackground.clear();
            buttonBackground.fillStyle(0x000000, 0.9);
            buttonBackground.fillCircle(0, 0, buttonRadius);
            buttonSymbol.setFill('#ffd700');
        });
        
        // Efecto click
        buttonContainer.on('pointerdown', () => {
            this.changeBet(amount);
            // Efecto de presión
            this.tweens.add({
                targets: buttonContainer,
                scaleX: 0.9,
                scaleY: 0.9,
                duration: 100,
                yoyo: true,
                ease: 'Power2'
            });
        });
        
        return buttonContainer;
    }
    
    
    createLightEffects() {
        // Luces parpadeantes en los bordes
        const lights = this.add.graphics();
        
        this.tweens.add({
            targets: lights,
            alpha: 0.3,
            duration: 1000,
            yoyo: true,
            repeat: -1,
            onUpdate: () => {
                lights.clear();
                lights.lineStyle(4, 0xffff00, lights.alpha);
                lights.strokeRect(0, 0, 1280, 720);
            }
        });
    }
    
    spin() {
        if (this.isSpinning) return;

        this.isSpinning = true;
        this.balance -= this.bet;
        this.winAmount = 0;
        this.updateUI();
        this.disableSpinButton();
        
        // Limpiar líneas ganadoras anteriores
        if (this.winningLinesContainer) {
            this.winningLinesContainer.destroy();
            this.winningLinesContainer = null;
        }
        
        this.sound.play('spin_sound');
        
        // PASO 1: Pre-determinar el resultado final ANTES de empezar a girar
        this.determineFinalResult();
        
        // PASO 2: Preparar los reels con las imágenes finales
        //this.prepareReelsWithFinalImages();
        
        // PASO 3: Animar la transición de símbolos
        this.animateSymbolsTransition();
    }
    

    
    // Método modificado: Primera fase de salida, luego segunda fase de entrada
    animateSymbolsTransition() {
        const totalReels = this.reels.length;
        let completedExitReels = 0;
        let completedEntryReels = 0;
        
        this.reels.forEach((reel, reelIndex) => {
            const symbols = reel.getAll();
            const symbolHeight = 500 / this.visibleSymbols;
            
            // FASE 1: Los símbolos bajan y desaparecen
            const exitDelay = reelIndex * 100; // Retraso escalonado por columna
            
            symbols.forEach((symbol, symbolIndex) => {
                this.tweens.add({
                    targets: symbol,
                    y: symbol.y + 500, // Bajar hasta salir de la pantalla
                    duration: 800,
                    delay: exitDelay + (symbolIndex * 50), // Retraso adicional por símbolo
                    ease: 'Power2',
                    onComplete: () => {
                        symbol.setVisible(false);
                        
                        // Verificar si este reel ha terminado la FASE 1
                        if (symbolIndex === 4) { // Último símbolo del reel
                            completedExitReels++;
                            
                            if (completedExitReels === totalReels) {
                                this.time.delayedCall(50, () => {
                                    this.startEntryPhase();
                                });
                            }
                        }
                    }
                });
            });
        });
    }
    
    // Nuevo método: Segunda fase - hacer bajar los símbolos desde arriba
    startEntryPhase() {
        const isMobile = this.deviceInfo?.isMobile || false;
        const totalReels = this.reels.length;
        let completedEntryReels = 0;
        
        this.reels.forEach((reel, reelIndex) => {
            const symbols = reel.getAll();
            const symbolHeight = 400 / this.visibleSymbols;
            
            // Retraso escalonado por columna para la entrada
            const entryDelay = reelIndex * 150;
            
            symbols.forEach((symbol, symbolIndex) => {
                // Cambiar la textura del símbolo a la imagen final
                const finalSymbols = this.finalResult[reelIndex];
                let textureToUse;
                if (symbolIndex < this.visibleSymbols) {
                    textureToUse = finalSymbols[symbolIndex];
                } else {
                    // Los extras tienen imágenes aleatorias
                    const randomSymbols = ['banana', 'monkey', 'treasure', 'leaf', 'coconut', 'flower', 'diamond', 'horseshoe'];
                    textureToUse = randomSymbols[Math.floor(Math.random() * randomSymbols.length)];
                }
                symbol.setTexture(textureToUse);
                
                // Posicionar el símbolo arriba de la pantalla (sin animación)
                //symbol.y = -100 + (symbolIndex * symbolHeight);
                symbol.y = -100;
                symbol.setVisible(true);
                
                // Animar hacia su posición final
                this.tweens.add({
                    targets: symbol,
                    y: symbolIndex * symbolHeight, // Posición final relativa al reel
                    duration: 600,
                    delay: entryDelay + (symbolIndex * 50), // Retraso escalonado
                    ease: 'Power2',
                    onComplete: () => {
                        // Cuando el símbolo llega a su posición final
                        if (symbolIndex < this.visibleSymbols) {
                            // Efecto de "aterrizaje" para símbolos visibles
                            this.tweens.add({
                                targets: symbol,
                                scaleX: isMobile ? 0.5 : 0.6,
                                scaleY: isMobile ? 0.5 : 0.6,
                                duration: 100,
                                yoyo: true,
                                onComplete: () => {
                                    symbol.setScale(isMobile ? 0.4 : 0.5); // Restaurar escala original
                                }
                            });
                        }
                        
                        // Verificar si este reel ha terminado la FASE 2
                        if (symbolIndex === 4) { // Último símbolo del reel
                            completedEntryReels++;
                            
                            if (completedEntryReels === totalReels) {
                                // TODA la FASE 2 ha terminado
                                this.time.delayedCall(500, () => {
                                    this.finalizeSpin();
                                });
                            }
                        }
                    }
                });
            });
        });
    }
    
    // Método modificado: Finalizar el spin
    finalizeSpin() {
        // Los símbolos ya están en su lugar, solo verificar ganancias
        this.checkWin();
        this.isSpinning = false;
        this.enableSpinButton();
    }
    

    
    checkWin() {
        // Verificar ganancia basada en el resultado pre-determinado
        let hasWin = false;
        let winGroups = []; // Array para almacenar los grupos ganadores
        
        // NUEVA LÓGICA: Buscar símbolos iguales adyacentes (incluyendo diagonales)
        const visited = Array(this.reelCount).fill().map(() => Array(this.visibleSymbols).fill(false));
        
        for (let reel = 0; reel < this.reelCount; reel++) {
            for (let symbol = 0; symbol < this.visibleSymbols; symbol++) {
                if (!visited[reel][symbol]) {
                    const currentSymbol = this.finalResult[reel][symbol];
                    const group = this.findConnectedSymbols(reel, symbol, currentSymbol, visited);
                    
                    if (group.positions.length >= 3) { // Mínimo 3 símbolos para ganar
                        hasWin = true;
                        winGroups.push({
                            symbol: currentSymbol,
                            positions: group.positions,
                            count: group.positions.length
                        });
                    }
                }
            }
        }
        
        if (hasWin) {
            // Calcular ganancia basada en el tamaño del grupo más grande
            const maxGroupSize = Math.max(...winGroups.map(g => g.count));
            this.winAmount = this.bet * this.calculateWinMultiplier(maxGroupSize);
            this.balance += this.winAmount;
            // Ocultar el texto inferior hasta que termine la animación de conteo
            this.isCountingWin = true;
            
            // Mostrar animación de grupos ganadores ANTES de la animación del mono
            this.showWinningLines(winGroups);
            
            // Esperar un poco antes de mostrar la animación del mono
            this.time.delayedCall(1500, () => {
                this.triggerWinAnimation();
            });
        }
        
        this.updateUI();
    }
    

    
    // Nuevo método: encontrar símbolos conectados (DFS)
    findConnectedSymbols(startReel, startSymbol, targetSymbol, visited) {
        const stack = [{ reel: startReel, symbol: startSymbol }];
        const positions = [];
        
        while (stack.length > 0) {
            const { reel, symbol } = stack.pop();
            
            if (reel < 0 || reel >= this.reelCount || 
                symbol < 0 || symbol >= this.visibleSymbols ||
                visited[reel][symbol] ||
                this.finalResult[reel][symbol] !== targetSymbol) {
                continue;
            }
            
            visited[reel][symbol] = true;
            positions.push({ reel, symbol });
            
            // Agregar vecinos adyacentes (horizontal, vertical y diagonal)
            const neighbors = [
                { reel: reel - 1, symbol: symbol },     // Izquierda
                { reel: reel + 1, symbol: symbol },     // Derecha
                { reel: reel, symbol: symbol - 1 },     // Arriba
                { reel: reel, symbol: symbol + 1 },     // Abajo
                { reel: reel - 1, symbol: symbol - 1 }, // Diagonal superior izquierda
                { reel: reel + 1, symbol: symbol - 1 }, // Diagonal superior derecha
                { reel: reel - 1, symbol: symbol + 1 }, // Diagonal inferior izquierda
                { reel: reel + 1, symbol: symbol + 1 }  // Diagonal inferior derecha
            ];
            
            neighbors.forEach(neighbor => {
                stack.push(neighbor);
            });
        }
        
        return { positions };
    }
    
    // Nuevo método: calcular multiplicador de ganancia
    calculateWinMultiplier(groupSize) {
        switch (groupSize) {
            case 3: return 2;
            case 4: return 5;
            case 5: return 10;
            case 6: return 20;
            case 7: return 50;
            case 8: return 100;
            case 9: return 200;
            case 10: return 500;
            default: return groupSize * 2;
        }
    }
    
    triggerWinAnimation() {
        // Mostrar contador de ganancia centrado
        this.startWinCounterAnimation();
        // Determinar qué animación mostrar según el monto de ganancia
        //this.showMonkeyGun();

       if (this.winAmount > 100) {
            this.showMonkeyGun();
        } else if (this.winAmount > 50) {
            // BIG WIN: Avión con tesoro
            this.treasureDropped = false; // Resetear flag
            this.showMonkeyPlane();
        } else {
            // SMALL WIN: Mono pequeño
            this.showMonkeySmallWin();
        }
        
        this.createWinParticles();
    }

    // Animación: contador de ganancia que aparece centrado, cuenta y baja a su posición oficial
    startWinCounterAnimation() {
        if (!this.winAmount || this.winAmount <= 0) {
            return;
        }
        this.isCountingWin = true;

        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const isMobile = this.deviceInfo?.isMobile || false;

        const startValue = 0.01;
        const endValue = Number(this.winAmount);

        // Estilo igual al de balance (dorado)
        const counterText = this.add.text(gameWidth / 2, gameHeight / 2, `$${startValue.toFixed(2)}`, {
            fontSize: isMobile ? '44px' : '56px',
            fill: '#ffd700',
            stroke: '#000000',
            strokeThickness: 6,
            fontFamily: 'Arial',
            fontWeight: 'bold'
        });
        counterText.setOrigin(0.5);
        counterText.setDepth(1000);
        counterText.setScale(0.8);
        counterText.setAlpha(0);

        // Aparición
        this.tweens.add({
            targets: counterText,
            alpha: 1,
            scale: 1.1,
            duration: 250,
            ease: 'Back.easeOut'
        });

        // Conteo de 0.01 hasta winAmount
        const duration = Math.min(1800, 600 + endValue * 20); // más rápido para montos pequeños
        const counterTween = this.tweens.addCounter({
            from: startValue,
            to: endValue,
            duration,
            ease: 'Quad.easeOut',
            onUpdate: (tween) => {
                const value = tween.getValue();
                counterText.setText(`$${value.toFixed(2)}`);
            },
            onComplete: () => {
                // Asegurar el valor final exacto
                counterText.setText(`$${endValue.toFixed(2)}`);

                // Mover a la posición oficial (this.winText)
                const targetX = this.winText.x;
                const targetY = this.winText.y;

                this.tweens.add({
                    targets: counterText,
                    x: targetX,
                    y: targetY,
                    scaleX: isMobile ? 0.9 : 1.0,
                    scaleY: isMobile ? 0.9 : 1.0,
                    duration: 500,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        // Mostrar texto oficial y destruir el contador
                        if (this.winText) {
                            this.winText.setText(`$${endValue.toFixed(2)}`);
                            this.winText.setVisible(true);
                        }
                        counterText.destroy();
                        this.isCountingWin = false;
                    }
                });
            }
        });
    }

    showMonkeyGun() {
        // Bajar el volumen del sonido de fondo específicamente
        //if (this.ambientSound) { this.ambientSound.setVolume(0.1); }
        
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const isMobile = this.deviceInfo?.isMobile || false;
        
        // Posicionar el mono con ametralladora a la izquierda
        const monkeyX = isMobile ? 50 : 100;
        const monkeyY = isMobile ? gameHeight * 0.6 : 400;
        const monkeyScale = isMobile ? 0.8 : 1.0;
        
        const monkey = this.add.sprite(monkeyX, monkeyY, 'monkeyGun').setScale(monkeyScale);
        monkey.play('monkeyShoot');
        
        // Vibración en dispositivos móviles durante el Big Win
        if (isMobile && typeof navigator !== 'undefined' && navigator.vibrate) {
            try {
                navigator.vibrate([80, 40, 80, 40, 120, 60, 120]);
            } catch (e) { /* noop */ }
        }

        // Sonido de disparos (usar el sonido de monedas como disparos)
        this.sound.play('coins_sound', { volume: 0.5 });
        
        // Disparar monedas hacia el centro
        this.startCoinShooting(monkeyX, monkeyY, gameWidth, gameHeight);
        
        // Texto de MEGA WIN
        const megaWinText = this.add.image(gameWidth / 2, gameHeight * 0.3, 'winText').setScale(1.2);
        this.tweens.chain({
            tweens: [
                { targets: megaWinText, alpha: 1, scale: 1.2, duration: 500, ease: 'Back.easeOut' },
                { targets: megaWinText, scale: 1.5, duration: 300, yoyo: true, repeat: 5 },
                { targets: megaWinText, alpha: 0, duration: 800, onComplete: () => megaWinText.destroy() }
            ]
        });
        
        // Terminar la animación después de 5 segundos
        this.time.delayedCall(5000, () => {
            monkey.destroy();
            //this.sound.stopAll();
            this.ambientSound.setVolume(0.3); 
            if (isMobile && typeof navigator !== 'undefined' && navigator.vibrate) {
                try { navigator.vibrate(0); } catch (e) { /* noop */ }
            }
        });
    }
    
    startCoinShooting(monkeyX, monkeyY, gameWidth, gameHeight) {
        const centerX = gameWidth / 2;
        const centerY = gameHeight / 2;
        
        // Disparar monedas cada 200ms
        const shootInterval = this.time.addEvent({
            delay: 200,
            callback: () => {
                this.shootCoin(monkeyX, monkeyY, centerX, centerY);
            },
            repeat: 20 // Disparar 20 veces
        });
    }
    
    shootCoin(startX, startY, targetX, targetY) {
        const coin = this.add.image(startX, startY, 'coin').setScale(0.3);
        
        // Hacer la moneda física
        this.physics.add.existing(coin);
        coin.body.setGravityY(800);
        coin.body.setBounce(0.4);
        coin.body.setCollideWorldBounds(true);
        
        // Calcular velocidad hacia el centro
        const angle = Phaser.Math.Angle.Between(startX, startY, targetX, targetY);
        const speed = 400;
        const velocityX = Math.cos(angle) * speed;
        const velocityY = Math.sin(angle) * speed;
        
        coin.body.setVelocity(velocityX, velocityY);
        
        // Animación de rotación mientras vuela
        this.tweens.add({
            targets: coin,
            angle: 360 * Phaser.Math.Between(3, 6), // Girar 3-6 vueltas
            duration: Phaser.Math.Between(1000, 2000),
            ease: 'Linear'
        });
        
        // Efecto de brillo
        this.tweens.add({
            targets: coin,
            alpha: 0.7,
            duration: 100,
            yoyo: true,
            repeat: 3
        });
        
        // Destruir la moneda después de 3 segundos
        this.time.delayedCall(3000, () => {
            if (coin.active) {
                this.tweens.add({
                    targets: coin,
                    alpha: 0,
                    scaleX: 0.1,
                    scaleY: 0.1,
                    duration: 500,
                    onComplete: () => {
                        coin.destroy();
                    }
                });
            }
        });
    }

    showMonkeySmallWin() {

        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        const isMobile = this.deviceInfo?.isMobile || false;

        this.sound.play('coins_sound');
        const xPos = isMobile ? 10 : 200;
        const yPos = isMobile ? gameHeight-100 : 500;
        const monkey = this.add.sprite(xPos, yPos, 'monkeySmallWin').setScale(0.8);
        monkey.play('monkeyWink');
        
        // Destruir el mono cuando termine la animación
        monkey.once('animationcomplete', () => {
            this.time.delayedCall(1500, () => {
                monkey.destroy();
            });
            
        });
       
        // 3. Moneda
        for (let i = 0; i < Phaser.Math.Between(6, 12); i++) {
            const coin = this.add.image(gameWidth-100, gameHeight-200, 'coin').setScale(0.6);
            this.tweens.add({
            targets: coin,
            x: 100 + Phaser.Math.Between(-120, 0),
            y: 800 + Phaser.Math.Between(-180, -250),
            alpha: 0.8,
            scale: 0.2,
            duration: 1000,
            ease: 'Quad.easeOut',
            delay: i * 50,
            onComplete: () => coin.destroy()
            });
        }
        // 4. Texto de ganancias
        const winText = this.add.image( gameWidth/2, gameHeight/2, 'winText');
        this.tweens.chain({
            tweens: [
              { targets: winText, alpha: 1, scale: 0.5, duration: 300, ease: 'Back.easeOut' },
              { targets: winText, scale: 0.7, duration: 200, yoyo: true, repeat: 2 },
              { targets: winText, alpha: 0, duration: 500, onComplete: () => winText.destroy() }
            ]
          }); 
    }
    
    showMonkeyPlane() {
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        // Bajar el volumen del sonido de fondo específicamente
        if (this.ambientSound) {
            this.ambientSound.setVolume(0.1); // Reducir a 10% del volumen original
        }
        //this.sound.play('plane_sound',{loop:true});
        this.sound.play('plane_sound');
        //this.sound.play('coins_sound');
        // 1. Crear el avión que vuela de izquierda a derecha
        const plane = this.add.image(-100, 200, 'plane').setScale(0.6);
      
        // 2. Animar el avión volando de izquierda a derecha en 2 segundos
        this.tweens.add({
            targets: plane,
            x: gameWidth+100, // Fuera de la pantalla por la derecha
            duration: 1500,
            ease: 'Linear',
            onUpdate: () => {
                // 3. Soltar el cofre del tesoro cuando esté en el medio
                if (plane.x > gameWidth/2 - 150 && plane.x < gameWidth/2 - 100 && !this.treasureDropped) {
                    this.treasureDropped = true;
                    this.dropTreasure(plane.x, plane.y + 50);
                    
                    // 4. Inclinar el avión hacia arriba y acelerar
                    this.tweens.add({
                        targets: plane,
                        angle: -15, // Inclinar hacia arriba
                        y: plane.y - 100, // Subir más alto
                        scaleX: 0.7, // Hacer el avión más grande (efecto de acercamiento)
                        scaleY: 0.7,
                        duration: 800,
                        ease: 'Power2',
                        onComplete: () => {
                            // 5. Continuar volando hacia arriba y más rápido
                            this.tweens.add({
                                targets: plane,
                                x: 1600, // Ir más lejos
                                y: plane.y - 150, // Subir más
                                angle: -25, // Inclinarse más
                                duration: 400,
                                ease: 'Power3',
                                onComplete: () => {
                                    plane.destroy();
                                    // Restaurar el volumen del sonido de fondo
                                    if (this.ambientSound) {
                                        this.ambientSound.setVolume(0.3); // Volver al volumen original
                                    }
                                }
                            });
                        }
                    });
                }
            },
            onComplete: () => {
                // Solo destruir si no se activó la secuencia de inclinación
                if (!this.treasureDropped) {
                    plane.destroy();
                    // Restaurar el volumen del sonido de fondo
                    if (this.ambientSound) {
                        this.ambientSound.setVolume(0.3); // Volver al volumen original
                    }
                }
            }
        });
        
        // 5. Texto de BIG WIN
        const bigWinText = this.add.image(gameWidth/2, gameHeight/2, 'winText').setScale(0.8);
        this.tweens.chain({
            tweens: [
                { targets: bigWinText, alpha: 1, scale: 0.8, duration: 400, ease: 'Back.easeOut' },
                { targets: bigWinText, scale: 1.0, duration: 300, yoyo: true, repeat: 3 },
                { targets: bigWinText, alpha: 0, duration: 600, onComplete: () => bigWinText.destroy() }
            ]
        });
    }
    
    dropTreasure(x, y) {
        // Crear el cofre del tesoro
        const treasure = this.add.image(x, y, 'treasure').setScale(1).setRotation(0.2);
        
        // Hacer el cofre físico para que caiga y rebote
        this.physics.add.existing(treasure);
        treasure.body.setGravityY(1000);
        treasure.body.setBounce(0.6);
        treasure.body.setCollideWorldBounds(true);
        this.sound.play('coins_sound');
        // Cuando el cofre toque el suelo, explotar en monedas
        this.physics.world.on('worldbounds', (event) => {
            if (event.body.gameObject === treasure && event.position.y > 500) {
                this.explodeTreasure(treasure.x, treasure.y);
                treasure.destroy();
            }
        });
        
        // También explotar después de un tiempo si no toca el suelo
        this.time.delayedCall(1100, () => {
            if (treasure.active) {
                this.explodeTreasure(treasure.x, treasure.y);
                treasure.destroy();
            }
        });
    }
    
    explodeTreasure(x, y) {
        // Reproducir sonido de monedas
        
        
        // Crear múltiples monedas con física
        const coinCount = Phaser.Math.Between(15, 25);
        
        for (let i = 0; i < coinCount; i++) {
            const coin = this.add.image(x, y, 'coin').setScale(0.4);
            
            // Hacer la moneda física
            this.physics.add.existing(coin);
            coin.body.setGravityY(500);
            coin.body.setBounce(0.3);
            coin.body.setCollideWorldBounds(true);
            
            // Aplicar velocidad aleatoria hacia arriba y los lados
            const velocityX = Phaser.Math.Between(-300, 300);
            const velocityY = Phaser.Math.Between(-400, -200); // Más fuerza hacia arriba
            
            coin.body.setVelocity(velocityX, velocityY);
            
            // Animación de rotación mientras cae
            this.tweens.add({
                targets: coin,
                angle: 360 * Phaser.Math.Between(2, 4), // Girar 2-4 vueltas completas
                duration: Phaser.Math.Between(1500, 2500),
                ease: 'Linear'
            });
            
            // Efecto de brillo en las monedas
            this.tweens.add({
                targets: coin,
                alpha: 0.8,
                duration: 200,
                yoyo: true,
                repeat: 3,
                delay: i * 50 // Retraso escalonado para efecto de cascada
            });
            
            // Destruir la moneda después de un tiempo
            this.time.delayedCall(1500, () => {
                if (coin.active) {
                    // Efecto de desvanecimiento antes de destruir
                    this.tweens.add({
                        targets: coin,
                        alpha: 0,
                        scaleX: 0.1,
                        scaleY: 0.1,
                        duration: 500,
                        onComplete: () => {
                            coin.destroy();
                        }
                    });
                }
            });
        }
        
        // Efecto de partículas de explosión
        for (let i = 0; i < 8; i++) {
            const particle = this.add.graphics();
            particle.fillStyle(0xffd700, 1);
            particle.fillCircle(0, 0, 3);
            
            const angle = (i / 8) * Math.PI * 2;
            const speed = 50 + Math.random() * 50;
            
            particle.x = x;
            particle.y = y;
            
            this.tweens.add({
                targets: particle,
                x: particle.x + Math.cos(angle) * speed,
                y: particle.y + Math.sin(angle) * speed,
                alpha: 0,
                scaleX: 0,
                scaleY: 0,
                duration: 800,
                ease: 'Power2',
                onComplete: () => {
                    particle.destroy();
                }
            });
        }
    }
    
    
    createWinParticles() {
        // Partículas de celebración deshabilitadas temporalmente
        // TODO: Implementar con la nueva API de partículas de Phaser 3.70.0
        console.log('Partículas de victoria deshabilitadas temporalmente');
    }
    
    determineFinalResult() {
        // Pre-determinar el resultado final ANTES de empezar a girar
        this.finalResult = [];
        
        this.reels.forEach((reel, reelIndex) => {
            const reelResult = [];
            
            // Determinar los 5 símbolos finales para este reel (cambiado de 6 a 5)
            for (let i = 0; i < this.visibleSymbols; i++) {
                const randomSymbol = this.symbols[Math.floor(Math.random() * this.symbols.length)];
                reelResult.push(randomSymbol);
            }
            
            this.finalResult.push(reelResult);
        });
        
    }
    
    prepareReelsWithFinalImages() {
        // Preparar los reels con las imágenes finales desde el inicio del giro
        this.reels.forEach((reel, reelIndex) => {
            const symbols = reel.getAll();
            const symbolHeight = 500 / this.visibleSymbols; // Ajustado para 5 símbolos
            const finalSymbols = this.finalResult[reelIndex];
            
            console.log(`Preparando reel ${reelIndex} con imágenes finales (5 símbolos):`, finalSymbols);
            
            // Distribuir las imágenes en todo el reel
            symbols.forEach((symbol, symbolIndex) => {
                // Calcular la posición Y para este símbolo
                let symbolY = symbolIndex * symbolHeight;
                
                let textureToUse;
                if (symbolIndex < this.visibleSymbols) {
                    // Los 5 primeros símbolos son las imágenes finales visibles
                    textureToUse = finalSymbols[symbolIndex];
                } else {
                    // Los símbolos extras tienen imágenes aleatorias para evitar superposición
                    const randomSymbols = ['banana', 'cherry', 'lemon', 'orange', 'grape', 'watermelon'];
                    textureToUse = randomSymbols[Math.floor(Math.random() * randomSymbols.length)];
                }
                
                // Asignar la textura
                try {
                    if (this.textures.exists(textureToUse)) {
                        symbol.setTexture(textureToUse);
                    } else {
                        symbol.setTexture('banana');
                    }
                } catch (error) {
                    console.log('Error preparando imagen:', error);
                    symbol.setTexture('banana');
                }
                
                // Restaurar escala original para evitar que se vean grandes
                symbol.setScale(0.5);
                
                // Posicionar el símbolo
                symbol.y = symbolY;
                symbol.setVisible(true);
                
                // Asegurar que los símbolos estén centrados horizontalmente en su reel
                symbol.setOrigin(0.5, 0.5);
            });
        });
        
        console.log('Reels preparados con imágenes finales (5 visibles) y aleatorias (extras) - listos para girar');
    }
    
    // setFinalSymbols() removido - ya no es necesario
    
    calculateSpinDistance(reelIndex, finalSymbols) {
        // Calcular la distancia de giro necesaria para llegar al resultado
        // Esto es más complejo y se puede implementar después
        // Por ahora, usamos una distancia fija
        return 400 * (3 + reelIndex); // Más giros para reels posteriores
    }
    
    // revealFinalResult() y repositionSymbols() removidos - ya no son necesarios
    
    changeBet(amount) {
        const newBet = this.bet + amount;
        if (newBet >= 10 && newBet <= 100) {
            this.bet = newBet;
            this.updateUI();
        }
    }
    
    updateUI() {
        this.balanceText.setText(`$${this.balance}`);
        this.betText.setText(`$${this.bet}`);
        
        // Mostrar/ocultar texto de ganancias
        if (this.winAmount > 0) {  
            this.winText.setText(`$${this.winAmount}`);
            // Ocultar el texto inferior mientras se realiza la animación de conteo
            if (!this.isCountingWin) {
                this.winText.setVisible(true);
            } else {
                this.winText.setVisible(false);
            }
        } else {
            this.winText.setVisible(false);
        }
    }
}

// Escena de victoria
class WinScene extends Phaser.Scene {
    constructor() {
        super({ key: 'WinScene' });
    }
    
    create() {
        // Fondo con efectos que cubra toda la pantalla
        this.createFullScreenBackground();
        
        // Mensaje de victoria
        const winText = this.add.text(640, 300, '¡GANASTE! 🎉', {
            fontSize: '64px',
            fill: '#ffd700',
            stroke: '#000000',
            strokeThickness: 6
        });
        winText.setOrigin(0.5);
        
        // Botón para volver a jugar
        const playAgainButton = this.add.text(640, 450, '🎰 JUGAR DE NUEVO 🎰', {
            fontSize: '32px',
            fill: '#00ff00',
            stroke: '#000000',
            strokeThickness: 2
        });
        playAgainButton.setOrigin(0.5);
        playAgainButton.setInteractive();
        
        playAgainButton.on('pointerdown', () => {
            this.scene.start('GameScene');
        });
        
        // Efectos de celebración
        this.createCelebrationEffects();
    }
    
    createCelebrationEffects() {
        // Confeti deshabilitado temporalmente
        // TODO: Implementar con la nueva API de partículas de Phaser 3.70.0
        console.log('Confeti de celebración deshabilitado temporalmente');
    }
    
    // Crear fondo que cubra toda la pantalla (equivalente a background-size: cover)
    createFullScreenBackground() {
        // Obtener dimensiones del juego
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;
        
        // Crear imagen de fondo
        const background = this.add.image(0, 0, 'background');
        
        // Centrar la imagen
        background.setOrigin(0, 0);
        
        // Calcular la escala necesaria para cubrir toda la pantalla
        const scaleX = gameWidth / background.width;
        const scaleY = gameHeight / background.height;
        
        // Usar la escala más grande para asegurar que cubra toda la pantalla
        const scale = Math.max(scaleX, scaleY);
        
        // Aplicar la escala
        background.setScale(scale);
        
        // Centrar la imagen en la pantalla
        background.setPosition(
            (gameWidth - (background.width * scale)) / 2,
            (gameHeight - (background.height * scale)) / 2
        );
        
        // Asegurar que esté detrás de todo
        background.setDepth(-1000);
        
        console.log('🎨 Fondo de victoria creado con escala:', scale);
    }
}

// Inicializar el juego
window.addEventListener('load', () => {
    new CheeckyMonkeyGame();
    
    // Ocultar pantalla de carga
    const loadingScreen = document.querySelector('.loading-screen');
    if (loadingScreen) {
        loadingScreen.style.display = 'none';
    }
});
